import React, { useState, useEffect } from 'react';

import './Footer.css';

function Footer() {

    return (
        <div className='footer'>
            <div>
                <div className='contact'>
                    <a href='mailto:contact@jillbryarsfigure.co.uk'>
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32">
                            <path d="M29 4H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h26a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm-.72 2L16 14.77 3.72 6zM30 25a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.23l13.42 9.58a1 1 0 0 0 1.16 0L30 7.23z"/>
                        </svg>
                    </a>
                    <a href="https://www.instagram.com/jillbryarsfigure" target="_blank" rel="noreferrer">
                        <img src='./res/Instagram_Glyph_Black.svg'>
                        </img>
                    </a>
                </div>
                <h4 className='name'>© 2026 Jill Bryars. All Rights Reserved.</h4>
                <h4 className='contact'><a href='mailto:contact@jillbryarsfigure.co.uk'>contact@jillbryarsfigure.co.uk</a></h4>
            </div>
        </div>
    );
}

export default (Footer);